import styled from "styled-components";

export const StyledAlert = styled.span`
  margin-top: 1rem;
  width: 100%;
  font-size: 1rem;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  background: var(--color-grey);
  color: #000;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;
